import { STATE } from "../../thor.const";

export class NeedHelpController {
    public static $inject: string[] = [
        "$rootScope",
        "$state",
        "configService",
        "sitesService"
    ];

    public hasSibling: boolean;
    public isHidden: boolean;

    constructor(
        $rootScope: ng.IRootScopeService,
        private $state: ng.ui.IStateService,
        public config,
        public sitesService
    ) {
        this.checkSibling();
        $rootScope.$on("$stateChangeSuccess", (_event, _toState) => this.checkSibling());
        $rootScope.$on("$stateChangeSuccess", (_event, _toState) => this.checkHidden());
    }

    private checkHidden() {
        this.isHidden =
            !this.$state.is(STATE.SALES.EDIT.ITEMS) &&
            !this.$state.is(STATE.ONLINE.EDIT.ITEMS);
    }

    private checkSibling() {
        this.hasSibling =
            this.$state.is(STATE.SALES.EDIT.ITEMS) ||
            this.$state.is(STATE.ONLINE.EDIT.ITEMS);
    }
}
